import React from 'react'
import SmartBanner from 'react-smartbanner'

import {
    forFeature,
    forWebView,
} from '../../validator'

import Configurator from '../../configurator'

@forFeature('SHOW_STORE_BANNER')
@forWebView(false)
export default class Banner extends Configurator {
    render = () => (
        <SmartBanner
            button="Zobrazit"
            daysHidden={30}
            daysReminder={60}
            title={this.config.REACT_APP_SYSTEM_NAME === 'Fajnovy sport Ostrava' ? 'Sportuj v Ostravě' : this.config.REACT_APP_SYSTEM_NAME}
            price={{
                ios: `Nainstalujte si aplikaci ${this.config.REACT_APP_SYSTEM_NAME === 'Fajnovy sport Ostrava' ? 'Sportuj v Ostravě' : this.config.REACT_APP_SYSTEM_NAME}`,
                android: `Nainstalujte si aplikaci ${this.config.REACT_APP_SYSTEM_NAME === 'Fajnovy sport Ostrava' ? 'Sportuj v Ostravě' : this.config.REACT_APP_SYSTEM_NAME}`,
            }}
            storeText={{
                ios: 'Zdarma v App Store',
                android: 'Zdarma v Google Play',
            }}
        />
    )
}
